import { FormBase } from 'core/components';
import validatorjs from 'validatorjs';

export default class ReportFilterForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}

	setup() {
		var Validator = validatorjs;
		Validator.register(
			'minValue',
			(inputValue, args, attribute) => {
				let minimumValue = ReportFilterForm.$('numberRangeStart').value;
				if (parseFloat(inputValue) < parseFloat(minimumValue) || parseFloat(inputValue) === parseFloat(minimumValue)) {
					return false;
				}
				return true;
			},
			'FILTER.NUMERIC.MINVALUE'
		);
		return {
			fields: [
				{
					name: 'contains',
					label: 'FILTER.FREETYPE.LABEL',
					placeholder: 'FILTER.FREETYPE.PLACEHOLDER',
				},
				{
					name: 'search',
					label: 'REPORTS.FILTER.SEARCH',
				},
				{
					name: 'specificNumber',
					label: 'FILTER.NUMBER',
					rules: 'numeric|numericMinValue|invalidCharacter',
				},
				{
					name: 'numberRangeStart',
					label: 'FILTER.NUMBERSTART',
					rules: 'numeric|numericMinValue|invalidCharacter',
				},
				{
					name: 'numberRangeEnd',
					label: 'FILTER.NUMBEREND',
					rules: 'numeric|numericMinValue|invalidCharacter',
				},
			],
		};
	}
}
